import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/website/assets/img/business/reports-statics.png?v=1")